/*!
 * @oarepo/invenio-oarepo-ui-quasar v1.3.3
 * (c) Miroslav Simek, CIS UCT Prague
 * Released under the MIT License.
 */
export { O as default } from './chunk-06fe2861.js';
import 'vue-runtime-helpers/dist/normalize-component.js';
import 'vue-property-decorator';
